<script>
  import { createEventDispatcher, onMount, tick } from 'svelte';
  import { uploadImage, getMultichannelConfig } from '../../../Api/api';
  import { categories, firebaseApp, user } from '../../../Store/store';
  import Button from '../../Common/Button.svelte';
  import Dialog from '../../Common/Dialog/Dialog.svelte';

  const dispatch = createEventDispatcher();

  export let open = false;
  export let isCreatingChannel = false;

  let inputEl;
  let channelName = '';
  let political = false;
  let selectedCategory = 'sport';
  let multichannelList;
  let selectedMultichannel;

  $: open && inputEl && focusInput();

  $: if (selectedCategory === 'multichannel') {
    getMultichannelConfigAsync();
  }

  const getMultichannelConfigAsync = async () => {
    let res = await getMultichannelConfig();
    if (res) {
      multichannelList = res;
    }
  };

  onMount(async () => {
    political = false;
    selectedCategory = 'sport';
    channelName = '';
    if (inputEl) {
      inputEl.focus();
    }
  });

  const focusInput = async () => {
    await tick();
    inputEl.focus();
  };

  const onOkClicked = async () => {
    let channelData = {
      name: channelName,
      createdBy: $user.uid,
      created: $firebaseApp.serverTimestamp,
      live: false,
      pushTitle: 'Live chat nå!',
      description: 'Chat med studio',
      pushTitleVideoStart: '🤩 Live video chat nå!',
      pushDescriptionVideoStart: '',
      archived: false,
      playout: 'HLS',
      category: selectedCategory,
      sendPushVideoLive: true,
      sendPushChatLive: true,
      ttl: political ? 24 : 24 * 3,
      political,
    };
    if (selectedMultichannel && selectedCategory === 'multichannel') {
      channelData.multichannel = selectedMultichannel;
    }
    dispatch('ok', channelData);
    channelName = '';
    political = false;
    selectedCategory = 'sport';
  };

  const onCancel = () => {
    channelName = '';
    political = false;
    selectedCategory = 'sport';
    dispatch('cancel');
  };

  const onImageFileChange = (e) => {
    uploadImage(e.target.files[0], (sh) => {
      const progress = (sh.bytesTransferred / sh.totalBytes) * 100;
      console.log(progress);
    })
      .then((url) => {
        console.log('DONE', url);
        imgUrl = url;
      })
      .catch((reason) => {
        console.error(`Failed to upload: ${reason}`);
      })
      .finally(() => console.log('FINALLY'));
  };
</script>

<Dialog
  title="Ny chat"
  {open}
  placeholder="Kanalnavn"
  isLoading={isCreatingChannel}
  on:cancel={onCancel}
>
  <div slot="content">
    <h3>Kategori</h3>
    <select bind:value={selectedCategory}>
      {#each $categories as category}
        {#if category.type !== 'all'}
          <option value={category.type}>{category.displayName}</option>
        {/if}
      {/each}
    </select>
    {#if multichannelList?.length > 0 && selectedCategory === 'multichannel'}
      <h3>Multichannel gruppe</h3>
      <select bind:value={selectedMultichannel}>
        {#each multichannelList as channel}
          <option value={channel.id}>{channel.name}</option>
        {/each}
      </select>
    {/if}
    <h3>Politisk innhold</h3>
    <input class="checkbox" type="checkbox" bind:checked={political} />
    <h3>Chat-rom navn</h3>
    <input bind:value={channelName} placeholder="Chat-rom navn" bind:this={inputEl} />
    <div class="btn-container">
      <Button on:click={onCancel} class="cancel-button" secondary>Avbryt</Button>
      <Button class="confirm-button" on:click={onOkClicked} disabled={channelName.length === 0}>
        Ok
      </Button>
    </div>
  </div>
</Dialog>

<style src="./createChannel.scss">
</style>
